<template lang="html">
  <div class="outerContainer">
    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-row 
      style="margin-bottom: -105px;"
    >
      <v-col cols="2">
        <v-autocomplete
          v-model="searchedEmployee"
          :items="employeeNames"
          class="ml-4"
          clearable
          hide-no-data
          hint
          hide-selected
          label="Employees"
          placeholder="Search Employees"
          item-text="name"
          item-value="employee_uid"
          filled
          background-color="white"
          @change="searchEmployeeInChart"
        />
      </v-col>
      
      <v-col 
        cols="2" 
        offset="8"
      >
        <v-autocomplete
          v-model="selectedKpiType"
          :items="kpiTypes"
          class="mr-4"
          hide-no-data
          hint
          hide-selected
          label="KPI Types"
          placeholder="Search KPI Types"
          item-text="name"
          return-object
          filled
          background-color="white"
          @change="loadChart"
        />
      </v-col>
    </v-row>

    <div id="root" />
    <v-card>
      <v-navigation-drawer 
        v-model="showDrawer"
        app
        floating
        width="600"
        temporary
        right
      >
        <v-toolbar
          class="ml-0" 
          color="success" 
          dark
        >
          <v-app-bar-nav-icon @click="showDrawer = false" />

          <v-toolbar-title class="white--text">
            Target Adjustment
          </v-toolbar-title>

          <v-spacer />
          <v-select
            v-model="selectedKpiTypeInEdit"
            :items="kpiTypes"
            return-object
            filled
            style="width:100px"
            item-text="name"
            label="Kpi Types"
            color="black"
            @change="getSubordinatesWithKpi"
          />
        </v-toolbar>
        
        <div 
          data-simplebar 
          class="overflow"
        >          
          <v-list
            two-line
            class="pb-4"
          > 
            <v-list-group
              v-for="(item,index) in computedSubordinates"
              :key="item.id"
              v-model="item.is_active"
              no-action
            >
              <template v-slot:activator>
                <v-list-item 
                  class="ma-2" 
                  style="border-bottom:none"
                >
                  <v-list-item-action>
                    <v-checkbox 
                      v-model="item.is_checked"
                      @click.stop="toggleCheckBox(index)"
                    />
                    <!-- @click.native.stop -->
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">
                      {{ item.person.name }}
                    </v-list-item-title> 
                    <v-list-item-subtitle class="green--text font-weight-medium">
                      Latest Target:RM {{ getTotal(item.kpi_targets) |toCurrency }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="mt-1 red--text font-weight-medium">
                      Feedback: RM {{ item.feedbackTotal }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
 
              <v-list-item-content>
                <v-form :ref="'form'+index">
                  <v-container 
                    v-if="showForm"
                    class="px-12 pb-1 pt-2"
                  >
                    <v-row>
                      <v-col 
                        v-for="(target,i) in item.kpi_targets" 
                        :key="i"
                        cols="6"
                      >
                        <!-- :rules="[rules.minimum]" -->
                        <v-text-field
                          :ref="'m'+i"
                          v-model="item.kpi_targets[i].value"
                          v-money="money"
                          :label="months[i]"
                          :filled="new Date().getMonth() >= i"
                          
                          required
                          prefix="RM"
                        />
                        <!-- :readonly="new Date().getMonth() > i ||
                          (new Date().getMonth() === i && new Date().getDate()>5) " -->

                        <!-- :readonly="new Date().getMonth() >= i" -->
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <!-- <v-card-actions> -->
                        <v-text-field
                          v-model="item.allocateAmount"
                          type="number"
                          class="ml-0"
                          label="Amount to Auto Allocate"
                          @change="item.is_checked = true"
                        />
                        
                        <!-- </v-card-actions>              -->
                      </v-col>
                      <v-col cols="6">
                        <v-btn
                          block
                          class="white--text"
                          color="deep-purple accent-4"
                          @click="generateTargetFromTotal(item.kpi_targets,item.allocateAmount)"
                        >
                          Auto Allocate
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-list-item-content>
            </v-list-group>
          </v-list>
        </div>

        <v-footer
          absolute
          height="82"
        > 
          <v-row>
            <v-col>
              <v-card-actions>
                <span 
                  v-if="!isIndividualTargetType" 
                  class="title"
                >Target : {{ sumOfSubordinateTarget|toCurrency }} / {{ sumOfSelfTarget|toCurrency }}</span>

                <v-spacer />
                <v-btn
                  text
                  @click="showDrawer = false"
                >
                  Close
                </v-btn>
                
                <!-- :disabled="disableSubmitButton" -->
                <!-- :disabled="!isTargetTally"  -->
                <v-btn
                  color="success"
                  @click="submitForm"
                >
                  Save 
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-footer>
      </v-navigation-drawer>
    </v-card>
  </div>
</template>

<script>
  import { VMoney } from 'v-money'

  import _ from 'lodash'
  import { mapState } from 'vuex'

  const { init, searchEmployee } = require('../../plugins/kpichart/chart')
  // const fakeData = require('../../plugins/orgchart/utils/fake-data')
  // const { children } = fakeData()

  export default {
    directives: { money: VMoney },
    metaInfo () {
      return {
        title: 'KPI Chart',
      }
    },
    data () {
      return {
        isLoading: false,
        defaultChartData: [],
        departmentList: [],
        searchedEmployee: '',
        selectedKpiType: null,
        selectedKpiTypeInEdit: null,
        showDrawer: false,
        right: true,
        subordinates: [],
        selfTarget: [],
        employeeNames: [],
        kpiTypes: [],
        months: [
          'January', 'February',
          'March', 'April', 'May', 
          'June', 'July', 'August', 
          'September', 'October', 
          'November', 'December',
        ],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 0,
          masked: false, /* doesn't work with directive */
        },
        rules: {
          minimum: value => {
            if (typeof value === 'string') {
              return value.replace(/,/g, '') > 0 || 'Value cannot less than 1'
            } else {
              return value > 0 || 'Value cannot less than 1'
            }
          },
        },
        firstTimeValidationClear: false,
        computedSubordinates: [],
        showForm: true,
      }
    },
    computed: {
      ...mapState(['currentEmployee']),
      // disableSubmitButton () {
      //   if (this.selectedKpiTypeInEdit === null) {        
      //     return true // disable
      //   } else {
      //     if (this.selectedKpiTypeInEdit.kpi_category_type.name === 'group') { // needs checking for group
      //       return !(this.isTargetTally && this.hasAnyChangedEmployees)// dont disable if tally
      //     }
        
      //     return false
      //   }
      // },
      isIndividualTargetType () {
        if (this.selectedKpiTypeInEdit) {
          if (this.selectedKpiTypeInEdit.kpi_category_type.name === 'individual') {
            return true
          }
        }
        return false
      },
      isTargetTally () {
        // return true
        if (this.isIndividualTargetType === true) {
          return true
        }

        return this.sumOfSelfTarget === this.sumOfSubordinateTarget && this.sumOfSubordinateTarget !== 0
      },
      allTileCollapsed () {
        let tileOpen = false
        this.subordinates.forEach((subordinate) => {
          if (subordinate.is_active === true) {
            tileOpen = true
          }
        })
      
        return !tileOpen
      },
      sumOfSubordinateTarget () {
        let total = 0
       
        this.computedSubordinates
          .filter((subordinate) => {
            return subordinate.is_checked === true // get only checked ones
          })
          .forEach((subordinate) => {
            if (subordinate.employee_uid !== this.currentEmployee.employee_uid) { // exclude self for top level
              total += this.getTotal(subordinate.kpi_targets)
            }
          })

        return total
      },
      sumOfSelfTarget () {
        if (this.selectedKpiTypeInEdit === null) {
          return 0
        }

        let total = 0
        if (this.selfTarget.length > 0) {
          this.selfTarget
            .filter((target) => {
              return target.kpi_category_id === this.selectedKpiTypeInEdit.id
            })        
            .forEach((target) => {
              total += target.value
            })
        }

        return total
      },
      numberOfChangedEmployees () {
        return this.prepareEmployeeFormData().length
      },
      hasAnyBIC () {
        return this.prepareBranchFormData().length
      },
      sumEmployeeTargetInEdit () {
        let data = _.cloneDeep(this.defaultChartData)

        if (!this.selectedKpiTypeInEdit) {
          return []
        }

        data.forEach((employee) => {
          // total self target
          employee.selfTargetTotal = 0
          employee.subordinateTotal = 0
          employee.feedbackTotal = 0
        })
      
        data.forEach((employee) => {
          if (employee.kpi_target_feedback.length > 0) {
            let feedbacks = employee.kpi_target_feedback
              .filter((feedback) => {
                return feedback.kpi_category_id === this.selectedKpiTypeInEdit.id
              })

            if (feedbacks.length > 0) { // if has selected kind
              employee.feedbackTotal += feedbacks[0].value
              data = this.addFeedbackToParent(data, employee.report_to.assigned_to, feedbacks[0].value)
            }
          }

          if (employee.kpi_targets) { // sum up kpi targets
            let targets = employee.kpi_targets
              .filter((target) => {
                return target.kpi_category_id === this.selectedKpiTypeInEdit.id
              })

            if (targets.length > 0) {
              employee.selfTargetTotal = targets.reduce((total, val) => total + val.value, 0)
            }
          } 
        })

        return data
      },
    },
    mounted () {
      window.kpichart = this
      Promise.all([
        this.$api.departments().list([], true),
        this.$api.kpiCategories().list(),
      ])
        .then(([department, kpiTypes]) => {
          this.departmentList = department.data
          this.kpiTypes = kpiTypes.data    
          this.setColorsForDepartment()
          this.getInitialData()
        })
    },
    updated () {
      if (!this.firstTimeValidationClear) {
        this.subordinates.forEach((sub, index) => {
        // this.$refs['form' + index][0].resetValidation()
        })
      // this.firstTimeValidationClear = true
      }
    },
    methods: {
      setColorsForDepartment () {
        let count = 0
        let colors = [
          'darkcyan', 'indigo', 'blue', 
          'purple', 'red', 'seagreen', 
          'blueviolet', 'darkgoldenrod', 'darkred',
          'orange',
        ]
        this.departmentList.forEach(function (departmentLists) {
          if (count >= 10) {
            count = 0
          }
          Object.assign(departmentLists, { colors: colors[count] })
          count++
        })
      },
      sumEmployeeTarget () {
        let t = this.timer()

        let data = _.cloneDeep(this.defaultChartData)

        data.forEach((employee) => {
          // total self target
          employee.selfTargetTotal = 0
          employee.selfActualSalesTotal = 0
          employee.subordinateTotal = 0
          employee.subordinateActualSalesTotal = 0
          employee.feedbackTotal = 0
          employee.feedbackRemark = ''
        })

        let d = _.cloneDeep(this.defaultChartData)

        data.forEach((employee) => {
          let children = this.getEmployeeChildren(employee.employee_uid, d)        
          employee.kpiName = this.selectedKpiType.name

          if (employee.kpi_target_feedback.length > 0) {
            let feedbacks = employee.kpi_target_feedback
              .filter((feedback) => {
                return feedback.kpi_category_id === this.selectedKpiType.id
              })

            if (feedbacks.length > 0) { // if has selected kind
              employee.feedbackTotal += feedbacks[0].value
              employee.feedbackRemark = feedbacks[0].remark
              data = this.addFeedbackToParent(data, employee.report_to.assigned_to, feedbacks[0].value)
            }
          }

          if ((employee.cro_performance || []).length > 0) { // has cro performance and reporting to someone
            employee.selfActualSalesTotal = employee.cro_performance.reduce((total, val) => total + val.net_capital_sales, 0)
          
            if (employee.report_to) {
              data = this.addSalesToParent(data, employee.report_to.assigned_to, employee.selfActualSalesTotal)
            }
          }

          children.forEach((subordinate) => {
            if (subordinate.kpi_targets) {
              employee.subordinateTotal += subordinate.kpi_targets
                .filter((target) => {
                  return target.kpi_category_id === this.selectedKpiType.id
                })
                .reduce((total, val) => total + val.value, 0)
            }
          })

          if (employee.kpi_targets) { // sum up kpi targets
            let targets = employee.kpi_targets
              .filter((target) => {
                return target.kpi_category_id === this.selectedKpiType.id
              })

            if (targets.length > 0) {
              employee.selfTargetTotal = targets.reduce((total, val) => total + val.value, 0)
            }
          } 
        })

        t.stop()

        return data
      },
      timer (x) {
        var start = new Date()
        return {
          stop: function () {
            var end = new Date()
            var time = end.getTime() - start.getTime()

            // eslint-disable-next-line
            console.log('Timer:', name, 'finished in', time, 'ms')
          },
        }
      },
      getEmployeeChildren (employeeUid, data) {
        return data.filter((employee) => {
          if (employee.report_to) {
            return employee.report_to.assigned_to === employeeUid
          } else {
            return false
          }
        })
      },
      addFeedbackToParent (data, parentUid, feedbackAmount) {
        data.forEach((employee) => {
          if (employee.employee_uid === parentUid) {
            employee.feedbackTotal += feedbackAmount

            if (employee.report_to) {
              data = this.addFeedbackToParent(data, employee.report_to.assigned_to, feedbackAmount) 
            }
          }
        })

        return data
      },
      addSalesToParent (data, parentUid, salesAmount) {
        data.forEach((employee) => {
          if (employee.employee_uid === parentUid) {
            employee.subordinateActualSalesTotal += salesAmount

            if (employee.report_to) {
              data = this.addSalesToParent(data, employee.report_to.assigned_to, salesAmount) 
            }
          }
        })

        return data
      },
      generateTargetFromTotal (kpi, amount) {
        if (!amount) {
          return
        }

        if (parseInt(amount.replace(/,/g, '')) < 1) {
          return 
        }
      
        let currentMonth = new Date().getMonth() // 6 
      
        let fixedTotals = kpi.reduce((total, current) => {
          if (current.month - 1 <= currentMonth) {
            return total + parseInt(current.value.replace(/,/g, ''))
          }
          return total
        }, 0)

        let remainingBalance = amount - fixedTotals 
        let remainingNumberOfMonths = 11 - currentMonth
      
        let perMonthAmount = (remainingBalance / remainingNumberOfMonths).toFixed(0)
        let toAllocate = []
        for (let x = 0; x < remainingNumberOfMonths - 1; x++) { // last month need to recalculate
          toAllocate.push(perMonthAmount)
        }

        let finalMonth = remainingBalance - (perMonthAmount * (remainingNumberOfMonths - 1))
        toAllocate.push(finalMonth)

        this.showForm = false
        toAllocate.forEach((amount, index) => {
          kpi[currentMonth + index + 1].value = amount
        })
 
        this.$nextTick(function () { // a kind of .then
          this.showForm = true
        })
      },
      getDepartmentList () {
        return this.departmentList
      },
      toggleCheckBox (index) {      
        this.$set(this.computedSubordinates[index], 'is_checked', !this.computedSubordinates[index].is_checked)     
      },
      getSubordinatesWithKpi () {
        this.showForm = false
        if (this.selectedKpiTypeInEdit) {
          this.computedSubordinates = _.cloneDeep(this.subordinates)
          let employees = this.sumEmployeeTargetInEdit

          this.computedSubordinates.forEach((subordinate, index) => {
            // console.log(employees.find(employee => employee.employee_uid === subordinate.employee_uid))
            subordinate.feedbackTotal = employees.find(employee => employee.employee_uid === subordinate.employee_uid).feedbackTotal

            let t = []

            subordinate.kpi_targets.forEach((target, index) => {
              if (target.kpi_category_id === this.selectedKpiTypeInEdit.id) {
                t.push(target)
              }
            })

            if (t.length === 0) {
              t = this.getEmptyModels(this.selectedKpiTypeInEdit.id)
              subordinate.is_checked = false
            } else {
              subordinate.is_checked = true // check people with this category
            }

            this.$set(this.computedSubordinates[index], 'kpi_targets', t)

            this.$nextTick(function () { // a kind of .then
              this.showForm = true
            })
          })
        }
      },
      removeKpiType (kpi) { // for multi select fitler, unused atm 
        let index = this.selectedKpiType.findIndex(selected => selected.id === kpi.id)
        if (index >= 0) this.selectedKpiType.splice(index, 1)
      },
      searchEmployeeInChart (employeeUid) {
        if (employeeUid) {
          searchEmployee(employeeUid)
        }
      },
      getTotal (targets) {
        let total = 0

        targets.forEach((target) => {
          if (typeof target.value === 'number') {
            total += target.value
          } else {
            total += parseInt(target.value.replace(/,/g, ''))
          }
        })

        return total
      },
      getInitialData () {
        this.isLoading = true

        this.$http.all([this.$api.kpiTarget().employeeOverview(), this.$api.kpiTarget().branchOverView()])
          .then(this.$http.spread((kpichart, branchKpi) => {
            kpichart.data.forEach((employee) => {
              employee.has_branch = false
            })

            branchKpi.data.forEach((branch) => {
              if (branch.user_in_charge) {
                let employee = kpichart.data.find((employee) => {
                  return employee.person_uid === branch.user_in_charge.person_uid
                })

                if (employee) {
                  employee.has_branch = true
                  employee.kpi_targets = branch.kpi_targets
                  employee.branch_uid = branch.branch_uid
                  employee.branch_name = '(BIC) ' + branch.branch_name
                }
              }

              if (branch.vessel_uid) {
                let vessel = kpichart.data.find((employee) => {
                  if (employee.person.user) {
                    return employee.person.user.user_uid === branch.vessel_uid
                  } else {
                    return false
                  }
                })

                if (vessel) {
                  vessel.has_branch = true
                  vessel.kpi_targets = branch.kpi_targets
                  vessel.branch_uid = branch.branch_uid
                  vessel.branch_name = '(Vessel) ' + branch.branch_name
                }
              }
            })
          
            if (!this.selectedKpiType) {
              this.selectedKpiType = this.kpiTypes[0]
            }

            this.defaultChartData = this.processKpiChartData(kpichart)          
            this.flatToHierarchy(this.sumEmployeeTarget())
            this.loadChart()
          }))          
      },
      loadChart () {
        // console.log(children)
        // init({ id: '#root', data: { children }, lineType: 'angle' })

        init({ id: '#root', data: { children: this.flatToHierarchy(this.sumEmployeeTarget()) }, lineType: 'angle' })
        this.isLoading = false
      },
      processKpiChartData (res) {
        let temp = []
        this.employeeNames = []

        res.data.forEach((employee) => {
          this.employeeNames.push({   
            employee_uid: employee.employee_uid,
            name: employee.person_with_user_region ? employee.person_with_user_region.name.substring(0, 23) : 'No Person',
          })

          let kpitarget = []
          employee.kpi_targets.forEach((target) => { // simplify target objects
            kpitarget.push({
              value: target.value,
              kpi_category_id: target.kpi_category_id,
              month: target.month,
            })
          })
          let toAdd = { // simplify employee objects
            id: employee.employee_uid,
            employee_uid: employee.employee_uid,
            departmentName: employee.department ? employee.department.name : employee.department,
            departmentId: employee.department_id,
            person: {
              avatar: employee.thumbnail_url,
              id: employee.employee_uid,
              name: employee.person_with_user_region ? employee.person_with_user_region.name : 'No Person',
              title: '',
              totalReports: 0,
              link: '#/orgchart/' + employee.employee_uid,
            },
            cro_performance: (((employee || {}).person || {}).user || false) ? employee.person.user.cro_performance : [],
            report_to: employee.report_to,
            has_branch: employee.has_branch,
            branch_uid: employee.branch_uid ? employee.branch_uid : null,
            branch_name: employee.branch_name ? employee.branch_name : null,
            kpi_targets: kpitarget,
            kpi_target_feedback: employee.kpi_target_feedback,
          }

          toAdd.person.title = (((employee.person_with_user_region || {}).user_region || {}).region || {}).region
          if (!toAdd.person.title) {
            toAdd.person.title = 'No region'
          }

          temp.push(toAdd)
        })

        return temp
      },
      flatToHierarchy (flat) {
        var roots = [] // things without parent
        // make them accessible by guid on this map
        var all = {}

        flat.forEach(function (item) {
          all[item.employee_uid] = item
          all[item.employee_uid].children = []
        })

        // connect childrens to its parent, and split roots apart
        Object.keys(all).forEach(function (uid) {
          var item = all[uid]

          if (item.report_to === null) {
            roots.push(item)
          } else {
            let found = false
            for (var key in all) {
              if (key === item.report_to.assigned_to) {
                found = true
              }
            }
        
            if (found === true) {
              var p = all[item.report_to.assigned_to]
              p.children.push(item)
          
              p.person.totalReports += 1
            
            // p.subordinateTotal += item.selfTargetTotal
            } else {
              roots.push(item) // if cannot find parent, it is the parent incase it has report ro
            }
          }
        })
    
        roots = roots.filter((employee) => {
          return (employee.children.length > 0 || (employee.children.length === 0 && employee.report_to !== null)) 
        })

        // console.log(roots)
        return roots.sort((a, b) => {
          return a.children.length < b.children.length ? 1 : -1 
        })
      },
      getEmptyModels (categoryId) {
        return [
          { value: '0', kpi_category_id: categoryId, month: 1 }, { value: '0', kpi_category_id: categoryId, month: 2 }, 
          { value: '0', kpi_category_id: categoryId, month: 3 }, { value: '0', kpi_category_id: categoryId, month: 4 }, 
          { value: '0', kpi_category_id: categoryId, month: 5 }, { value: '0', kpi_category_id: categoryId, month: 6 },
          { value: '0', kpi_category_id: categoryId, month: 7 }, { value: '0', kpi_category_id: categoryId, month: 8 }, 
          { value: '0', kpi_category_id: categoryId, month: 9 }, { value: '0', kpi_category_id: categoryId, month: 10 }, 
          { value: '0', kpi_category_id: categoryId, month: 11 }, { value: '0', kpi_category_id: categoryId, month: 12 },
        ]
      },
      showCard (children, selfTarget) {
        this.computedSubordinates = [] // empty subordinates
        this.selfTarget = selfTarget
        // console.log(children)

        let tempChild = []      
        this.showDrawer = true

        children.forEach((child) => {
          tempChild.push({ // get only used fields cause there are possibly null fields,avoid circular json conversion
            employee_uid: child.employee_uid,
            kpi_targets: child.kpi_targets,
            person: child.person,
            is_checked: false,
            is_active: false,
            has_branch: child.has_branch,
            branch_uid: child.branch_uid,
          })
        })

        this.subordinates = tempChild

        this.selectedKpiTypeInEdit = this.selectedKpiType// set to what is selected outside
        this.getSubordinatesWithKpi(this.selectedKpiTypeInEdit) // manually load first time
      },
      validateForm () { // unused for now
        let validation = false

        for (let x = 0; x < this.subordinates.length; x++) {
          if (!this.$refs['form' + x][0].validate()) {
            this.subordinates[x].is_active = true
            this.$refs['form' + x][0].validate()
            break
          }

          if (x === this.subordinates.length - 1) {
            validation = true
          }
        }
        return validation
      },
      prepareBranchFormData () {
        let branchesToUpdate = []
        this.computedSubordinates
          .filter((subordinate) => {
            return subordinate.is_checked === true && subordinate.has_branch === true // get only checked ones
          })
          .forEach((subordinate, subIndex) => {
            let branch = {
              branch_uid: subordinate.branch_uid,
              kpi_targets: [],
              kpi_category_id: null,
            }

            subordinate.kpi_targets.forEach((newTarget, targetIndex) => {
              let currentTarget = typeof newTarget.value === 'number' ? newTarget.value : parseInt(newTarget.value.replace(/,/g, ''))

              if (this.subordinates[subIndex].kpi_targets.length === 0 || this.zeroOrNotEqual(currentTarget, this.subordinates[subIndex].kpi_targets[targetIndex].value)) {
                branch.kpi_targets.push({
                  month: targetIndex + 1,
                  value: parseInt(newTarget.value.replace(/,/g, '')),

                })
                branch.kpi_category_id = newTarget.kpi_category_id
              }
            })

            if (branch.kpi_targets.length > 0) {
              branchesToUpdate.push(branch)
            }
          })

        return branchesToUpdate
      },
      zeroOrNotEqual (current, previous) {
        if (current === 0) {
          return true
        }
        return current !== previous
      },
      prepareEmployeeFormData () {
        let employeesToUpdate = []
        this.computedSubordinates
          .filter((subordinate) => {
            return subordinate.is_checked === true && subordinate.has_branch === false // get only checked ones
          })
          .forEach((subordinate, subIndex) => {
            let employee = {
              employee_uid: subordinate.employee_uid,
              kpi_targets: [],
              kpi_category_id: null,
            }

            subordinate.kpi_targets.forEach((newTarget, targetIndex) => {
              let currentTarget = typeof newTarget.value === 'number' ? newTarget.value : parseInt(newTarget.value.replace(/,/g, ''))

              if (this.subordinates[subIndex].kpi_targets.length === 0 || this.zeroOrNotEqual(currentTarget, this.subordinates[subIndex].kpi_targets[targetIndex].value)) {
                employee.kpi_targets.push({
                  month: targetIndex + 1,
                  value: parseInt(newTarget.value.replace(/,/g, '')),

                })
                employee.kpi_category_id = newTarget.kpi_category_id
              }
            })

            if (employee.kpi_targets.length > 0) {
              employeesToUpdate.push(employee)
            }
          })

        return employeesToUpdate
      },
      submitForm () {
        if (this.validateForm()) {
          let promises = []

          let employees = this.prepareEmployeeFormData()

          employees.forEach((employee) => {
            promises.push(this.$http.put('/api/employees/' + employee.employee_uid + '/kpi-targets', employee))
          })

          let branches = this.prepareBranchFormData()
        
          branches.forEach((branch) => {
            promises.push(this.$http.put('/api/branches/' + branch.branch_uid + '/branch-kpi-targets', branch))
          })

          this.$http.all(promises)
            .then(this.$http.spread((...res) => {
              this.getInitialData()
              this.showDrawer = false
              this.$snack({
                message: 'Target Updated Successfully',
              })
            }))
            .catch((err) => {
              this.showDrawer = false

              this.$snack({
                message: err,
              })
            })
        }
      },
    
    },
  }

</script>

<style scoped>
  .overflow::-webkit-scrollbar { 
    display: none;  
  }

  ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }

</style>

<style lang="css">

  #core-view .theme--light.v-footer{
    border-top:none
  }

  .overflow {
    /* overflow-y: scroll;  */
    height: 85vh;
  }

  html, body {
      /* margin: 0;
      height: 100%;
      width: 100%; */
      font-size: 12px;
      font-family: "SF UI Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
      font-smoothing: antialiased;
      -webkit-font-smoothing: antialiased;
    }

    .outerContainer {
      /* overflow-y:scroll; */
      /* height:100%;
      width:100%; */
      /* position: absolute; */
    }

    #root {
      /* margin: 0; */
      cursor: move;
      /* height: 100%;
      width: 100%; */
      background-color:#f7f9fa;
    }
    .org-chart-person-name {
      font-weight: 500;
    }
    .fa:hover{
      fill: #409CF9 !important;
    }
    .org-chart-node:hover .org-chart-person-reports {
      fill: #409CF9 !important;
    }
    .org-chart-person-dept.engineering {
      fill: #4CAF50 !important; 
    }
    .org-chart-person-dept.communications {
      fill: #3F51B5 !important; 
    }
    .org-chart-person-dept.product {
      fill: #D500F9 !important; 
    }
    .org-chart-person-dept.hr {
      fill: #2196F3 !important; 
    }
    .org-chart-person-dept.marketing {
      fill: #F44336 !important; 
    }
    .org-chart-person-dept.design {
      fill: #26C6DA !important; 
    }

    circle {
      fill: none;
      stroke: #000000;
    }
</style>
